module.exports = __webpack_public_path__ + "img/notification-template.556b1723.svg";